module.exports = __webpack_public_path__ + "img/description4.b62c8b50.jpg";